import React, { useRef, useMemo, memo, useEffect, useState } from 'react';
import { pick } from 'ramda';
import { useAuthSelector, useUserSelector } from 'js/store/hooks';
import { BackboneWrapper } from 'js/backbone/components/BackboneWrapper';

import * as helpers from './helpers';

/**
 * This component is here only while we still have Backbone replacers.
 * It should be removed as soon as the last replacer is migrated to be a real React component.
 */
export const BackboneReplacerBare = (props) => {
    const [el, setEl] = useState();
    const view = useRef();
    const { dynamicName, viewName, args } = props;
    const { isLoggedIn } = useUserSelector(pick(['isLoggedIn']));
    const { isLoginInProcess, isLogoutInProcess } = useAuthSelector(pick(['isLoginInProcess', 'isLogoutInProcess']));

    const View = useMemo(() => {
        const replacers = helpers.getBackboneReplacerViews();

        return replacers[viewName];
    }, [viewName]);

    useEffect(() => {
        if (!el) {
            return;
        }

        const params = args?.split(',') || [];

        view.current = new View({
            el,
            name: dynamicName,
            params
        });

        view.current.render(...params);

        return () => {
            if (view.current) {
                view.current.remove();
            }
        };
    }, [
        el,
        View,
        dynamicName,
        args
    ]);

    if (isLoggedIn && isLoginInProcess || !isLoggedIn && isLogoutInProcess) {
        return null;
    }

    return <BackboneWrapper el={setEl} tagName={View.prototype.tagName} />;
};

export const BackboneReplacer = memo(BackboneReplacerBare);
